import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface FatalDetails {
  status?: number;
  isKeyCloakError?: boolean;
}

@Injectable({ providedIn: 'root' })
export class FatalErrorService {
  private readonly state$ = new BehaviorSubject<boolean>(false);
  private readonly details$ = new BehaviorSubject<FatalDetails | null>(null);

  get fatal$(): Observable<boolean> {
    return this.state$.asObservable();
  }

  get active(): boolean {
    return this.state$.value;
  }

  get details(): FatalDetails | null {
    return this.details$.value;
  }

  setFatal(active: boolean): void {
    this.state$.next(active);
  }

  setDetails(details: FatalDetails | null): void {
    this.details$.next(details);
  }

  clear(): void {
    this.state$.next(false);
    this.details$.next(null);
  }
}